/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useContext } from 'react';
import { SignableDocument, SignableDocumentRecipient, SignablePrescripteur } from './types';

let dossierId: number | undefined;

let prescripteur: SignablePrescripteur | undefined;

const documents: Array<SignableDocument> = [];

const recipients: Array<SignableDocumentRecipient> = [];

const modalOpen: boolean = false;

const allowAddDocument: boolean = false;

const setDossierId: React.Dispatch<React.SetStateAction<number | undefined>> = () => {};

const setPrescripteur: React.Dispatch<
    React.SetStateAction<SignablePrescripteur | undefined>
> = () => {};

const setModalOpen: React.Dispatch<React.SetStateAction<boolean>> = () => {};

const setAllowAddDocument: React.Dispatch<React.SetStateAction<boolean>> = () => {};

const addDocument = (document: SignableDocument) => {};

const replaceDocuments = (newDocuments: Array<SignableDocument>) => {};

const addRecipient = (recipient: SignableDocumentRecipient) => {};

const removeRecipient = (recipient: SignableDocumentRecipient) => {};

const clear = () => {};

const DocumentSignModalContext = createContext({
    dossierId,
    prescripteur,
    documents,
    recipients,
    modalOpen,
    allowAddDocument,
    setDossierId,
    setPrescripteur,
    setModalOpen,
    addDocument,
    replaceDocuments,
    addRecipient,
    removeRecipient,
    setAllowAddDocument,
    clear,
});

export const useDocumentSignModalContext = () => useContext(DocumentSignModalContext);

export default DocumentSignModalContext;
